import $ from 'jquery';
import { MapService } from './map.service';

const MOUSE_X_OFFSET = 10;
const MOUSE_Y_OFFSET = -30;
const MAP_SELECTOR = '#main-map-container';
const TOOLTIP_SELECTOR = '#map-tooltip';

export class MapTooltipService {
    private _active: boolean;
    private _tooltipHtml: string;

    private _tooltipElement: JQuery;
    private _mapElement: JQuery;

    constructor(mapService: MapService) {
        this._active = false;
        this._tooltipHtml = '';
        mapService.addOnViewerReadyListener(
            (
                mapService: MapService,
                mapElement = $(MAP_SELECTOR),
                tooltipElement = $(TOOLTIP_SELECTOR),
            ) => {
                this._setupMapElement(mapElement, tooltipElement);
            },
        );
    }

    private _setupMapElement(mapElement: JQuery, tooltipElement: JQuery): void {
        this._mapElement = mapElement;
        this._tooltipElement = tooltipElement;
        this._mapElement.on('mousemove', (e) => {
            this.setPosition(e.offsetX, e.offsetY);
        });
        this._mapElement.on('mouseleave', () => {
            this.setPosition(0, 0);
        });
    }

    public setPosition(x: number, y: number): void {
        if (this._active) {
            this._tooltipElement.css(
                'transform',
                `translate(${x + MOUSE_X_OFFSET}px, ${y + MOUSE_Y_OFFSET}px)`,
            );
        }
    }

    public setActive(active: boolean): void {
        if (active) {
            this._tooltipElement.show();
        } else {
            this._tooltipElement.hide();
        }
        this._active = active;
    }

    public setTooltip(htmlStr: JQuery.htmlString): void {
        this._setContent(htmlStr);
        this.setActive(true);
    }

    private _setContent(htmlStr: JQuery.htmlString): void {
        if (this._tooltipHtml !== htmlStr) {
            this._tooltipHtml = htmlStr;
            this._tooltipElement.html(htmlStr);
        }
    }
}
